import * as Scrivito from "scrivito";

Scrivito.provideComponent("NewsCategoryConfigWidget", ({ widget }) => (
  <Scrivito.WidgetTag className="container">
    <h2>News categories</h2>
    <div className="row">
      <div className="col-sm font-weight-bold text-uppercase text-center">
        Key
      </div>
      <div className="col-sm  font-weight-bold text-uppercase text-center">
        de
      </div>
      <div className="col-sm font-weight-bold text-uppercase text-center ">
        en
      </div>
    </div>
    <Scrivito.ContentTag tag="div" content={widget} attribute="body" />
  </Scrivito.WidgetTag>
));
